module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/confirm_en-bf898e5398a78e5ab480ba072d97ddf1.gif";